import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { queryBuilder } from '@wix/sdk-runtime/query-builder';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixEcomV1CheckoutTemplate from './ecom-v1-checkout-template-checkout-templates.http.js';
// @ts-ignore
import { transformSDKImageToRESTImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformSDKPageURLV2ToRESTPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformRESTPageURLV2ToSDKPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    Status["ACTIVE"] = "ACTIVE";
    Status["INACTIVE"] = "INACTIVE";
})(Status || (Status = {}));
export var DescriptionLineType;
(function (DescriptionLineType) {
    /** Unrecognized type. */
    DescriptionLineType["UNRECOGNISED"] = "UNRECOGNISED";
    /** Plain text type. */
    DescriptionLineType["PLAIN_TEXT"] = "PLAIN_TEXT";
    /** Color type. */
    DescriptionLineType["COLOR"] = "COLOR";
})(DescriptionLineType || (DescriptionLineType = {}));
/** Type of selected payment option for catalog item */
export var PaymentOptionType;
(function (PaymentOptionType) {
    /** The entire payment for this item happens as part of the checkout. */
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    /** The entire payment for this item happens after checkout. For example, when using cash, check, or other offline payment methods. */
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    /** Payment for this item is done by charging a membership. When selected, `price` is `0`. */
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    /** Partial payment to be paid upfront during checkout. The initial amount to be paid for each line item is specified in `depositAmount`. */
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    /** Payment for this item can only be done by charging a membership and must be manually redeemed in the dashboard by the site admin. When selected, `price` is `0`. */
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(PaymentOptionType || (PaymentOptionType = {}));
export var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["SERVICE"] = "SERVICE";
})(ItemTypeItemType || (ItemTypeItemType = {}));
/** Frequency unit of recurring payment */
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export var FileType;
(function (FileType) {
    FileType["UNSPECIFIED"] = "UNSPECIFIED";
    FileType["SECURE_PICTURE"] = "SECURE_PICTURE";
    FileType["SECURE_VIDEO"] = "SECURE_VIDEO";
    FileType["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
    FileType["SECURE_MUSIC"] = "SECURE_MUSIC";
    FileType["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
})(FileType || (FileType = {}));
export var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN_TAXABLE_ADDRESS"] = "UNKNOWN_TAXABLE_ADDRESS";
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    TaxableAddressType["BILLING"] = "BILLING";
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType || (TaxableAddressType = {}));
/** JurisdictionType represents the type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
export var JurisdictionType;
(function (JurisdictionType) {
    JurisdictionType["UNDEFINED"] = "UNDEFINED";
    JurisdictionType["COUNTRY"] = "COUNTRY";
    JurisdictionType["STATE"] = "STATE";
    JurisdictionType["COUNTY"] = "COUNTY";
    JurisdictionType["CITY"] = "CITY";
    JurisdictionType["SPECIAL"] = "SPECIAL";
})(JurisdictionType || (JurisdictionType = {}));
export var ItemAvailabilityStatus;
(function (ItemAvailabilityStatus) {
    ItemAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** Item does not exist. */
    ItemAvailabilityStatus["NOT_FOUND"] = "NOT_FOUND";
    /** Item is not in stock. */
    ItemAvailabilityStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    /** Available quantity is less than requested. */
    ItemAvailabilityStatus["PARTIALLY_AVAILABLE"] = "PARTIALLY_AVAILABLE";
})(ItemAvailabilityStatus || (ItemAvailabilityStatus = {}));
/** tax info types */
export var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    /** CPF - for individual tax payers. */
    VatType["CPF"] = "CPF";
    /** CNPJ - for corporations */
    VatType["CNPJ"] = "CNPJ";
})(VatType || (VatType = {}));
export var PickupMethod;
(function (PickupMethod) {
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
})(PickupMethod || (PickupMethod = {}));
export var ChargeType;
(function (ChargeType) {
    ChargeType["HANDLING_FEE"] = "HANDLING_FEE";
    ChargeType["INSURANCE"] = "INSURANCE";
})(ChargeType || (ChargeType = {}));
export var RuleType;
(function (RuleType) {
    RuleType["VALIDATION"] = "VALIDATION";
    RuleType["OTHER"] = "OTHER";
    RuleType["MAX"] = "MAX";
    RuleType["MIN"] = "MIN";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
    RuleType["EXACT_LENGTH"] = "EXACT_LENGTH";
    RuleType["EXACT_SIZE"] = "EXACT_SIZE";
    RuleType["REQUIRED_ONE_OF_FIELD"] = "REQUIRED_ONE_OF_FIELD";
})(RuleType || (RuleType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["GLOBAL"] = "GLOBAL";
    DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    DiscountType["SHIPPING"] = "SHIPPING";
})(DiscountType || (DiscountType = {}));
export var WeightUnit;
(function (WeightUnit) {
    /** Weight unit can't be classified due to an error. */
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    /** Kilograms. */
    WeightUnit["KG"] = "KG";
    /** Pounds. */
    WeightUnit["LB"] = "LB";
})(WeightUnit || (WeightUnit = {}));
export var RateType;
(function (RateType) {
    /** no tax being collected for this request due to location of purchase */
    RateType["NO_TAX_COLLECTED"] = "NO_TAX_COLLECTED";
    /** manual rate used for calculation */
    RateType["MANUAL_RATE"] = "MANUAL_RATE";
    /** autotax rate used for calculation */
    RateType["AUTO_RATE"] = "AUTO_RATE";
    /** fallback rate used for calculation */
    RateType["FALLBACK_RATE"] = "FALLBACK_RATE";
})(RateType || (RateType = {}));
export var ManualCalculationReason;
(function (ManualCalculationReason) {
    /** user set calculator in Business Manager to be Manual */
    ManualCalculationReason["GLOBAL_SETTING_TO_MANUAL"] = "GLOBAL_SETTING_TO_MANUAL";
    /** specific region is on manual even though Global setting is Auto-tax */
    ManualCalculationReason["REGION_SETTING_TO_MANUAL"] = "REGION_SETTING_TO_MANUAL";
})(ManualCalculationReason || (ManualCalculationReason = {}));
export var FallbackReason;
(function (FallbackReason) {
    /** auto-tax failed to be calculated */
    FallbackReason["AUTO_TAX_FAILED"] = "AUTO_TAX_FAILED";
    /** auto-tax was temporarily deactivated on a system-level */
    FallbackReason["AUTO_TAX_DEACTIVATED"] = "AUTO_TAX_DEACTIVATED";
})(FallbackReason || (FallbackReason = {}));
export var ChannelType;
(function (ChannelType) {
    /** Unspecified sales channel. This value is not supported. */
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    /** A web client. */
    ChannelType["WEB"] = "WEB";
    /** [Point of sale solutions](https://support.wix.com/en/wix-mobile-pos-2196395). */
    ChannelType["POS"] = "POS";
    /** [eBay shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-ebay-shop). */
    ChannelType["EBAY"] = "EBAY";
    /** [Amazon shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-amazon-shop). */
    ChannelType["AMAZON"] = "AMAZON";
    /** Other sales platform. */
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    /** [Wix Owner app](https://support.wix.com/article/wix-owner-app-an-overview). */
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    /** Wix Invoices app in [your dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Finvoices/settings/general-settings) */
    ChannelType["WIX_INVOICES"] = "WIX_INVOICES";
    /** Wix merchant backoffice. */
    ChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    /** Wish sales channel. */
    ChannelType["WISH"] = "WISH";
    /** [ClassPass sales channel](https://support.wix.com/en/article/wix-bookings-letting-clients-book-your-services-with-classpass). */
    ChannelType["CLASS_PASS"] = "CLASS_PASS";
    /** Global-E sales channel. */
    ChannelType["GLOBAL_E"] = "GLOBAL_E";
    /** [Facebook shop](https://support.wix.com/en/article/wix-stores-changes-to-facebook-shops). */
    ChannelType["FACEBOOK"] = "FACEBOOK";
    /** [Etsy sales channel](https://support.wix.com/en/article/wix-stores-request-adding-etsy-as-a-sales-channel). */
    ChannelType["ETSY"] = "ETSY";
    /** [TikTok sales channel](https://support.wix.com/en/article/wix-stores-request-adding-tiktok-as-a-sales-channel). */
    ChannelType["TIKTOK"] = "TIKTOK";
    /** [Faire marketplace integration](https://support.wix.com/en/article/wix-stores-creating-a-faire-store-using-the-faire-integration-app). */
    ChannelType["FAIRE_COM"] = "FAIRE_COM";
})(ChannelType || (ChannelType = {}));
export var AdditionalFeeSource;
(function (AdditionalFeeSource) {
    AdditionalFeeSource["UNKNOWN_ADDITIONAL_FEE_SOURCE"] = "UNKNOWN_ADDITIONAL_FEE_SOURCE";
    /** The additional fee was added by an additional fee service plugin */
    AdditionalFeeSource["SERVICE_PLUGIN"] = "SERVICE_PLUGIN";
    /** The additional fee was added on the item either via the catalog or on custom line item */
    AdditionalFeeSource["ITEM"] = "ITEM";
    /** The additional fee was added manually on the request */
    AdditionalFeeSource["MANUAL"] = "MANUAL";
})(AdditionalFeeSource || (AdditionalFeeSource = {}));
export var Severity;
(function (Severity) {
    /** The user is allowed to move forward in the flow. */
    Severity["WARNING"] = "WARNING";
    /**
     * The user is blocked from moving forward in the flow.
     * For example, if callerContext is CART - moving to checkout is blocked. if callerContext is CHECKOUT, placing an order is blocked.
     */
    Severity["ERROR"] = "ERROR";
})(Severity || (Severity = {}));
/** Available locations on the webpage */
export var NameInOther;
(function (NameInOther) {
    /** Default location, in case no specific location is specified. */
    NameInOther["OTHER_DEFAULT"] = "OTHER_DEFAULT";
})(NameInOther || (NameInOther = {}));
/** Available locations on the line item */
export var NameInLineItem;
(function (NameInLineItem) {
    /** Default location, in case no specific location is specified. */
    NameInLineItem["LINE_ITEM_DEFAULT"] = "LINE_ITEM_DEFAULT";
})(NameInLineItem || (NameInLineItem = {}));
export var SuggestedFix;
(function (SuggestedFix) {
    /** No suggested fix is specified. The user should refer to the violation description to resolve the issue. */
    SuggestedFix["UNKNOWN_SUGGESTED_FIX"] = "UNKNOWN_SUGGESTED_FIX";
    /** The line item should be removed from the cart or checkout to resolve the violation. */
    SuggestedFix["REMOVE_LINE_ITEM"] = "REMOVE_LINE_ITEM";
})(SuggestedFix || (SuggestedFix = {}));
export var SortOrder;
(function (SortOrder) {
    /** Ascending order. */
    SortOrder["ASC"] = "ASC";
    /** Descending order. */
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
/**
 * Creates a checkout template.
 *
 * A checkout template is used to create a new checkout that will include predefined information. For example, a single link with
 * a `checkoutTemplateId` can be shared with customers and each time the link is clicked, a new checkout page will be created
 * for that customer with certain checkout information already populated.
 *
 * The customizable features include the option to allow or to lock coupon codes or gift cards. For example, if a store owner is
 * using the checkout template to offer a flash sale to their social media followers, they may want to lock the option to apply an
 * additional coupon on top of the sale being offered. If so, they can set `customization.lockedCoupon` to `true`.
 *
 * A checkout can be created with a checkout template by calling Create Checkout From Template.
 * The site may add further customizations to the new checkout and then redirect the customer using the new checkout's `checkoutUrl`.
 * @param checkoutTemplate - Checkout template to create.
 * @public
 * @requiredField checkoutTemplate
 * @requiredField checkoutTemplate.customLineItems.descriptionLines.name
 * @requiredField checkoutTemplate.customLineItems.descriptionLines.value
 * @requiredField checkoutTemplate.customLineItems.itemType
 * @requiredField checkoutTemplate.customLineItems.productName
 * @requiredField checkoutTemplate.customLineItems.quantity
 * @requiredField checkoutTemplate.lineItems.catalogReference
 * @requiredField checkoutTemplate.lineItems.catalogReference.appId
 * @requiredField checkoutTemplate.lineItems.catalogReference.catalogItemId
 * @requiredField checkoutTemplate.lineItems.quantity
 * @permissionId ECOM.CHECKOUT_TEMPLATE_CREATE
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @returns Created checkout template.
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.CreateCheckoutTemplate
 */
export async function createCheckoutTemplate(checkoutTemplate) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplate: checkoutTemplate,
    }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'checkoutTemplate.lineItems.catalogOverrideFields.image' },
                { path: 'checkoutTemplate.customLineItems.media' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [{ path: 'checkoutTemplate.customLineItems.url' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.createCheckoutTemplate(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'checkoutTemplate.lineItems.catalogOverrideFields.image' },
                    { path: 'checkoutTemplate.customLineItems.media' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'checkoutTemplate.customLineItems.url' }],
            },
        ]))?.checkoutTemplate;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { checkoutTemplate: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['checkoutTemplate']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a checkout template.
 * @param checkoutTemplateId - ID of the checkout template to retrieve.
 * @public
 * @requiredField checkoutTemplateId
 * @permissionId ECOM.CHECKOUT_TEMPLATE_READ
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @returns Retrieved checkout template.
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.GetCheckoutTemplate
 */
export async function getCheckoutTemplate(checkoutTemplateId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplateId: checkoutTemplateId,
    });
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.getCheckoutTemplate(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'checkoutTemplate.lineItems.catalogOverrideFields.image' },
                    { path: 'checkoutTemplate.customLineItems.media' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'checkoutTemplate.customLineItems.url' }],
            },
        ]))?.checkoutTemplate;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { checkoutTemplateId: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['checkoutTemplateId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates a checkout template.
 *
 * If the info in a checkout template is updated, only new checkouts created from this template will include the updated items. Checkouts previously
 * created from this template before the update will not be affected.
 * @param _id - Checkout template ID.
 * @public
 * @requiredField _id
 * @requiredField checkoutTemplate
 * @param checkoutTemplate - Checkout template info to update.
 * @permissionId ECOM.CHECKOUT_TEMPLATE_UPDATE
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @returns Updated checkout template.
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.UpdateCheckoutTemplate
 */
export async function updateCheckoutTemplate(_id, checkoutTemplate) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplate: { ...checkoutTemplate, id: _id },
    }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'checkoutTemplate.lineItems.catalogOverrideFields.image' },
                { path: 'checkoutTemplate.customLineItems.media' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [{ path: 'checkoutTemplate.customLineItems.url' }],
        },
    ]);
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.updateCheckoutTemplate(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'checkoutTemplate.lineItems.catalogOverrideFields.image' },
                    { path: 'checkoutTemplate.customLineItems.media' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [{ path: 'checkoutTemplate.customLineItems.url' }],
            },
        ]))?.checkoutTemplate;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: { checkoutTemplate: '$[1]' },
            explicitPathsToArguments: { 'checkoutTemplate.id': '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id', 'checkoutTemplate']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes a checkout template.
 *
 * If a checkout template is deleted and a customer attempts to create a checkout with that `checkoutTemplateId` then
 * the customer will be redirected to the domain site.
 * @param checkoutTemplateId - ID of the checkout template to delete.
 * @public
 * @requiredField checkoutTemplateId
 * @permissionId ECOM.CHECKOUT_TEMPLATE_DELETE
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.DeleteCheckoutTemplate
 */
export async function deleteCheckoutTemplate(checkoutTemplateId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplateId: checkoutTemplateId,
    });
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.deleteCheckoutTemplate(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { checkoutTemplateId: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['checkoutTemplateId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Creates a query to retrieve a list of checkout templates.
 *
 * The `queryCheckoutTemplates()` function builds a query to retrieve a list of checkout templates and returns a `CheckoutTemplatesQueryBuilder` object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the `find()` function.
 *
 * You can refine the query by chaining `CheckoutTemplatesQueryBuilder` functions onto the query. `CheckoutTemplatesQueryBuilder` functions enable you to sort, filter, and control the results that `queryCheckoutTemplates()` returns.
 *
 * `queryCheckoutTemplates()` runs with the following `CheckoutTemplatesQueryBuilder` default that you can override:
 * + `ascending("_id")`
 *
 * The functions that are chained to `queryCheckoutTemplates()` are applied in the order they are called. For example, if you apply `ascending("status")` and then `ascending("_id")`, the results are sorted first by the `"status"`, and then, if there are multiple results with the same `"status"`, the items are sorted by `"_id"`.
 *
 * The following `CheckoutTemplatesQueryBuilder` functions are supported for the `queryCheckoutTemplates()` function. For a full description of the checkout template object, see the object returned for the `items` property in `CheckoutTemplatesQueryResult`.
 * @public
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @permissionId ECOM.CHECKOUT_TEMPLATE_READ
 * @applicableIdentity APP
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.QueryCheckoutTemplates
 */
export function queryCheckoutTemplates() {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[0];
    return queryBuilder({
        func: async (payload) => {
            const reqOpts = ambassadorWixEcomV1CheckoutTemplate.queryCheckoutTemplates(payload);
            sideEffects?.onSiteCall?.();
            try {
                const result = await httpClient.request(reqOpts);
                sideEffects?.onSuccess?.(result);
                return result;
            }
            catch (err) {
                sideEffects?.onError?.(err);
                throw err;
            }
        },
        requestTransformer: (query) => {
            const args = [query, {}];
            return renameKeysFromSDKRequestToRESTRequest({
                ...args?.[1],
                query: args?.[0],
            });
        },
        responseTransformer: ({ data, }) => {
            const transformedData = renameKeysFromRESTResponseToSDKResponse(transformPaths(data, [
                {
                    transformFn: transformRESTImageToSDKImage,
                    paths: [
                        {
                            path: 'checkoutTemplates.lineItems.catalogOverrideFields.image',
                        },
                        { path: 'checkoutTemplates.customLineItems.media' },
                    ],
                },
                {
                    transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                    paths: [{ path: 'checkoutTemplates.customLineItems.url' }],
                },
            ]));
            return {
                items: transformedData?.checkoutTemplates,
                pagingMetadata: transformedData?.pagingMetadata,
            };
        },
        errorTransformer: (err) => {
            const transformedError = sdkTransformError(err, {
                spreadPathsToArguments: {},
                explicitPathsToArguments: { query: '$[0]' },
                singleArgumentUnchanged: false,
            });
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: {},
    });
}
/**
 * Creates a new checkout based on the checkout template.
 *
 * Before using this method, you must have a checkout template available. Create a checkout template with Create Checkout Template.
 *
 * The customer can be directed to the new checkout using the checkout's `checkoutUrl`.
 * @param checkoutTemplateId - ID of the checkout template to use to create a checkout from.
 * @param siteId - ID of the site associated with the checkout template.
 * @public
 * @requiredField checkoutTemplateId
 * @requiredField siteId
 * @permissionId ECOM.CHECKOUT_TEMPLATE_CREATE_CHECKOUT
 * @permissionScope Manage Stores - all permissions
 * @permissionScopeId SCOPE.DC-STORES-MEGA.MANAGE-STORES
 * @permissionScope Manage Restaurants - all permissions
 * @permissionScopeId SCOPE.RESTAURANTS.MEGA-SCOPES
 * @permissionScope Manage eCommerce - all permissions
 * @permissionScopeId SCOPE.DC-ECOM-MEGA.MANAGE-ECOM
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.CreateCheckoutFromTemplate
 */
export async function createCheckoutFromTemplate(checkoutTemplateId, siteId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplateId: checkoutTemplateId,
        siteId: siteId,
    });
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.createCheckoutFromTemplate(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                checkoutTemplateId: '$[0]',
                siteId: '$[1]',
            },
            singleArgumentUnchanged: false,
        }, ['checkoutTemplateId', 'siteId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Creates a new checkout based on the checkout template and redirects to the new checkout page.
 *
 * Before using this method, you must have a checkout template available. Create a checkout template with Create Checkout Template.
 *
 * To build a URL that uses this method, follow this format:
 * `https://www.wixapis.com/ecom/v1/checkout-templates/{checkoutTemplateId}/create-and-redirect-to-checkout?siteId={siteId}`
 *
 * To create a checkout but not automatically redirect to the checkout page, use Create Checkout From Template.
 * @param checkoutTemplateId - ID of the checkout template to use to create a checkout.
 * @param siteId - ID of the site associated with the checkout template.
 * @public
 * @requiredField checkoutTemplateId
 * @requiredField siteId
 * @fqn wix.ecom.checkout_template.api.v1.CheckoutTemplateService.CreateAndRedirectToCheckout
 */
export async function createAndRedirectToCheckout(checkoutTemplateId, siteId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        checkoutTemplateId: checkoutTemplateId,
        siteId: siteId,
    });
    const reqOpts = ambassadorWixEcomV1CheckoutTemplate.createAndRedirectToCheckout(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                checkoutTemplateId: '$[0]',
                siteId: '$[1]',
            },
            singleArgumentUnchanged: false,
        }, ['checkoutTemplateId', 'siteId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=ecom-v1-checkout-template-checkout-templates.universal.js.map